import { CirclePlay, Forward, Heart, Info, MessageSquareText, Percent } from 'lucide-react';

import type { Post } from '@/entities/post/post-types';
import { MetricCard } from '@/shared/components/metric-card';
import { TooltipFlat } from '@/shared/components/shadcn/tooltip/tooltip-flat';

export const PostPerformance = ({ post }: { post: Post }) => {
  return (
    <div className="flex gap-6">
      <MetricCard
        className="flex-1"
        title={
          <div className="flex items-center gap-1">
            <CirclePlay size={16} />
            views
          </div>
        }
        value={post.extraction.engagement.view}
      />
      <MetricCard
        className="flex-1"
        title={
          <div className="flex items-center gap-1">
            <MessageSquareText size={16} />
            comments
          </div>
        }
        value={post.extraction.engagement.comment}
      />
      <MetricCard
        className="flex-1"
        title={
          <div className="flex items-center gap-1">
            <Heart size={16} />
            likes
          </div>
        }
        value={post.extraction.engagement.like}
      />
      <MetricCard
        className="flex-1"
        title={
          <div className="flex items-center gap-1">
            <Forward size={16} />
            shares
          </div>
        }
        value={post.extraction.engagement.shared}
      />
      <MetricCard
        className="flex-1"
        title={
          <TooltipFlat
            asChild
            contentClassName="w-96"
            content={
              <>
                <span className="font-bold">Engagement Rate</span>
                <br />
                [(likes + comments + shares)/ views]
                <br />
                <br />
                <span className="font-bold">Example:</span>
                <br />
                [(100 + 50 + 25)/ 1000] = 0.175 (17.5%)
              </>
            }
          >
            <div className="flex w-fit items-center gap-1">
              Post
              <Percent size={16} />
              ER
              <Info className="size-3.5" />
            </div>
          </TooltipFlat>
        }
        suffix="%"
        value={Number((post.extraction.engagement.rate * 100).toFixed(1))}
      />
    </div>
  );
};
